/** The messages of a GAINS Connect error body: `{ Reason }` for one, `{ Reasons }` for several. */
export function getApiErrorMessages(error: any): string[] {
  const body = error?.error;
  if (Array.isArray(body?.Reasons)) {
    return body.Reasons.filter((reason: any) => typeof reason === 'string');
  }
  return typeof body?.Reason === 'string' ? [body.Reason] : [];
}
